import React, { useMemo } from 'react';

import Button from '../../../core/components/button/button';
import { ButtonType } from '../../../core/components/button/button-enums';
import Tooltip from '../../../core/components/tooltip/tooltip';
import { useLocale } from '../../../core/hooks/use-locale';

interface Props {
  filters: Array<{
    label: string;
    value: any;
    deactivate: () => void;
  }>;
  defaultDeactivate?: () => void;
}

const FilterBadges = ({ filters, defaultDeactivate }: Props) => {
  const { Message } = useLocale();

  const activeFilters = useMemo(() => filters.filter(({ value }) => value), [
    filters,
  ]);

  return activeFilters.length ? (
    <div className="filter-badges">
      {activeFilters.map(({ label, value, deactivate }) => (
        <div key={label} className="filter-badges__item">
          <span>
            {label}: <kbd>{`${value}`.truncate(50)}</kbd>
          </span>
          <Tooltip title={Message.CANCEL}>
            <Button
              onClick={() => {
                deactivate();
                defaultDeactivate && defaultDeactivate();
              }}
              buttonType={ButtonType.CLEAR}
              aria-label={Message.CANCEL}
            ></Button>
          </Tooltip>
        </div>
      ))}
    </div>
  ) : null;
};

export default FilterBadges;
